<div class="container">
  <div class="row" >

    <div class="col-md-12 col-sm-12 scroll-table" [ngClass]="{'table-modal': isModal}">
      <button *ngIf="isModal && alertasNaoVisto?.length > 0" class="btn btn-primary btn-sm mt-4 ms-2" (click)="marcaAlertaVisualizado()">Marca como visualizado(s)</button>
      <table class="table table-sm m-2">
        <thead>
          <tr class="font-weight-bold">
            <th scope="col"> </th>
            <th scope="col">Roteiro</th>
            <th scope="col">Motorista</th>
            <th scope="col">Motivo</th>
            <th scope="col">Data e Hora</th>
            <th *ngIf="isModal" scope="col">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let alerta of alertas" class="hover-pedido">
            <td class="w-drop small-cell">
              <div class="dropdown hover-btn dropdown">
                <i class="fa fa-ellipsis-v" style="padding: 5px;" data-bs-toggle="dropdown"></i>
                <div class="dropdown-menu shadow" style="border-radius: 8px;">
                  <button data-bs-toggle="modal" data-bs-target="#modalPrincipal"  (click)="abrirMapa(alerta)" class="dropdown-item mb-1" >
                    <img class="icone_roteiro" src="assets/img/icons/icon_mapa.svg" class="me-3">Visualizar no mapa
                  </button>
                  <button data-bs-toggle="modal" class="dropdown-item mb-1" (click)="ocorrencia(alerta)" >
                    <img class="icone_roteiro" [src]="'assets/img/icons/icon_ocorrencia' + (alerta.OcorrenciaID == null? '' : '_eye') + '.svg'" class="me-3">{{alerta.OcorrenciaID == null? 'Criar': 'Ver'}} ocorrência
                  </button>
                </div>
              </div>
            </td>
            <td >{{ alerta.NumeroRoteiro }} </td>
            <td> {{ alerta.NomeMotorista }} </td>
            <td> {{ alerta.TipoAlerta }} </td>
            <td> <app-data-horario [data]="alerta.DTAlerta"></app-data-horario> </td>
            <td *ngIf="isModal"><app-pill-alertas [alerta]="alerta"></app-pill-alertas> </td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</div>
